<template>
  <div class="table-queue block">
    <div :class="'table-queue__wrapper ' + blockWrapperClass ">
      <div class="table-queue__header" :class="{'hidden': hiddenHeader}">
        <div class="table-queue__header-wrapper">
          <div class="table-queue__header-side">
            <div class="table-queue__logo" :class="{'hidden': hiddenLogo}">
              <img :src="logo" class="logo-img" alt="logo">
            </div>
          </div>
          <div class="table-queue__header-main">
            <Time/>
          </div>
          <div class="table-queue__speaker">
            <PlayList/>
          </div>
        </div>
      </div>
      <div class="table-queue__main">
        <PaginatorList v-if="showPaginatorHelper">
          <PaginatorItem v-for="item in maxCountPage"
                         :active="isActive(item)"
                         :key="`paginator-item-${item}`"
                         :title="item"/>
        </PaginatorList>
        <template v-if="trySetClient">
          <template v-if="!loadingDataError">
            <template v-if="isAdPolicyOnlyAd">
              <AdPlayList
                v-if="playlistMainItems.length > 0"
                :play-list-items="playlistMainItems"
              />
            </template>
            <template v-if="!isAdPolicyOnlyAd">
              <template v-if="clientsEmpty">
                <LogoEmpty v-if="isAdPolicyDefault || playlistMainItems.length === 0"/>
                <AdPlayList
                  v-if="(isAdPolicyEmptyClients || isAdPolicyAlways) && playlistMainItems.length > 0"
                  :play-list-items="playlistMainItems"
                />
              </template>
              <TableManager v-if="!clientsEmpty" :tickets="currentTickets" />
            </template>
          </template>
          <template v-else>
            <template v-if="accessDeniedError">
              <Loader queue-table-error-title-hook text-small class="_text-short _text-center _gap-inner-top-2" queue-table-loader-hook>
                {{$t('error.accessDenied1')}}
              </Loader>
              <div queue-table-error-desc-hook class="_text-center _gap-inner-top-1" v-html="$t('error.accessDenied2')"></div>
            </template>
            <template v-else>
              <div queue-table-error-title-hook class="_text-size-24 _text-center _gap-inner-top-2">
                {{ $t('error.loading') }}
              </div>
              <div queue-table-error-desc-hook class="_text-center _gap-inner-top-1">
                {{$t('common.makeConnection')}}
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <div class="_gap-inner-top-2">
            <Loader queue-table-loader-hook>Загрузка</Loader>
          </div>
        </template>
        <audio queue-table-audio-hook ref="auto" src="../../../assets/audio/song.mp3"></audio>
      </div>
      <div class="table-queue__footer" v-if="textPlayListExist">
        <AdPlayListText />
      </div>
      <div class="table-queue__socket" style="display: none" :class="`${socketConnect && definedSocketConnect ? 'is-connect' : ''}`">
        •
      </div>
      <AdPlayListAudio
        v-if="playlistsAudioItemsNotEmpty"
        class="table-queue__audio"
        :play-list-audio-items="playlistsAudioItems"
      />
    </div>
  </div>
</template>

<script>
  import TableQueueController from './table-queue-controller'
  // components
  import Time from '@/components/times/Time'
  import Loader from '@/components/loaders/Loader'
  import PlayList from '@/components/playlist/PlayList'
  import TableManager from '@/components/table/TableManager'
  import AdPlayList from '@/components/playlist/AdPlayList'
  import AdPlayListText from '@/components/playlist/AdPlayListText'
  import PaginatorItem from '@/components/paginator/PaginatorItem'
  import PaginatorList from '@/components/paginator/PaginatorList'
  import LogoEmpty from '@/components/logos/LogoEmpty'
  import AdPlayListAudio from '@/components/playlist/AdPlayListAudio.vue'
  import { mapState } from 'vuex'
  import { colorSchemes } from '@/app/const/settings'

  export default {
    name: 'TableQueue',
    mixins: [TableQueueController],
    components: {
      AdPlayListAudio,
      AdPlayList,
      AdPlayListText,
      Time,
      Loader,
      PlayList,
      TableManager,
      PaginatorItem,
      PaginatorList,
      LogoEmpty
    },
      computed: {
          ...mapState({
              guiSettings: state => state.gui.settings
          }),
          colorScheme () {
              return this.guiSettings.colorScheme
          },
          blockWrapperClass () {
              return this.colorScheme.code === colorSchemes.baucenter ? '' : 'block-wrapper'
          }
      }
  }
</script>
